import { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'lib/router'

export type UseTabControl = (
  paths: string[]
) => [tabIndex: number, handleTabChange: (index: number) => void]

// Syncs the selected Jutsu Tab with the current URL
export const useTabControl: UseTabControl = paths => {
  const history = useHistory()
  const location = useLocation()
  const [tabIndex, setTabIndex] = useState(0)
  const handleTabChange = (index: number) => {
    const path = paths[index]
    setTabIndex(index)
    if (path && path !== location.pathname) {
      history.push(path)
    }
  }

  useEffect(() => {
    if (paths.length > 0) {
      // Set the selected Tab based on the current URL
      const index = paths.findIndex(path => path === location.pathname)
      if (index < 0) {
        history.push(paths[0])
        setTabIndex(0)
      } else {
        setTabIndex(index)
      }
    }
  }, [paths, location.pathname, history])

  return [tabIndex, handleTabChange]
}
